import { useSelector } from 'react-redux';

import { Box } from '@frontend/legacy-components';

import MeasurementComparison from 'modules/common/viewer/cadViewer/addOns/MeasurementComparisonDisplay';
import MetaDataDisplay from 'modules/common/viewer/cadViewer/addOns/MetaDataDisplay';
import SelectorCumulativeInfo from 'modules/common/viewer/cadViewer/addOns/SelectorCumulativeInfo';
import VolumeAreaWeightDisplay from 'modules/common/viewer/cadViewer/addOns/VolumeAreaWeightDisplay';
import { getShowDxfControls } from 'modules/common/viewer/cadViewer/data/reducer';
import { getActiveFileProperties } from 'modules/common/viewer/data/reducer';
import { useIsActiveFile3DRenderable } from 'modules/common/viewer/hooks/useActiveViewerKind';

/**
 * Floating bottom-right readouts for the CAD viewer. Reads everything it needs
 * from the store — callers render it with no props.
 */
const CADViewerInfo = () => {
  const activeFileProperties = useSelector(getActiveFileProperties);
  const isActiveFile3DRenderable = useIsActiveFile3DRenderable();
  const showDxfControls = useSelector(getShowDxfControls);

  return (
    <Box
      bottom="10px"
      right="20px"
      position="absolute"
      zIndex={2}
      color={showDxfControls ? 'black' : 'white'}
    >
      <SelectorCumulativeInfo isEnabled={isActiveFile3DRenderable} />
      <MeasurementComparison isEnabled={isActiveFile3DRenderable} />
      <MetaDataDisplay isEnabled={isActiveFile3DRenderable} />
      <VolumeAreaWeightDisplay
        isEnabled={isActiveFile3DRenderable}
        properties={activeFileProperties}
      />
    </Box>
  );
};

export default CADViewerInfo;
